<template>
  <div>
    <div class="text-subtitle-2">{{this.title}}</div>
    <v-divider class="marg-title"></v-divider>
  </div>
</template>

<script>
export default {
  name: "TitlePage",
  props: ['title']
}
</script>

<style scoped>
.marg-title{
  margin: 10px 0;
}
</style>